import {StyleSheet} from "aphrodite";

// eslint-disable-next-line no-restricted-imports -- TODO(FEI-7300): Replace with new semanticColor
import {color, semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";

export const styles = StyleSheet.create({
    highlight: {
        display: "inline",
        position: "relative",
        font: "inherit",
        lineHeight: "inherit",
        margin: "inherit",
        padding: "inherit",
        color: "currentColor",
        height: "100%",
        backgroundColor: color.fadedPurple8,
        "@media print": {
            background: "none",
            backgroundColor: "transparent",
        },
    },
    cursorLine: {
        color: semanticColor.khanmigo.primary,
        width: 0,
        outline: `1px solid ${semanticColor.khanmigo.primary}`,
        position: "relative",
        pointerEvents: "none",
        userSelect: "none",
    },
    cursorLabel: {
        position: "absolute",
        top: -2,
        insetInlineEnd: 0,
        fontFamily: "Lato, sans-serif",
        fontSize: 11,
        lineHeight: "1.8em",
        height: "1.8em",
        fontWeight: "bold",
        pointerEvents: "none",
        userSelect: "none",
        padding: `0 ${spacing.xxxxSmall_2}px`,
        color: semanticColor.core.foreground.knockout.default,
        backgroundColor: semanticColor.khanmigo.primary,
        transform: "translate(100%, -100%)",
        borderStartEndRadius: spacing.xxxSmall_4,
        borderEndEndRadius: spacing.xxxSmall_4,
        borderStartStartRadius: spacing.xxxSmall_4,
    },
});
